<template>
  <div class="main-win" :style="{width: width}">
    <div class="wrapper-win">
      <div class="header">
        <h3>
          <a>{{ title }}</a>
        </h3>
      </div>
      <div class="body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>


    export default {
        name: "SpaceWindow",
        props: {
            //窗口title
            title: {
                type: String,
                required: true
            },
            //窗口宽度
            width: {
                type: String,
                required: false,
            }
        }
    }
</script>

<style scoped>
  .main-win {
    border: 1px #c7e5eb solid;
    border-radius: 4px;
  }

  .main-win > .wrapper-win > .header {
    background-color: rgba(242, 253, 255, 1);
    border-bottom: 1px #ddedf0 solid;
    height: 35px;
    line-height: 35px;
  }

  .main-win > .wrapper-win > .header h3 {
    margin-left: 10px;
    font-size: 15px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/view/baseComponent/SpaceWindow.vue